import { Pipe, PipeTransform } from '@angular/core';
import { PageResult } from 'src/app/shared/model/page/page-result';

@Pipe({
  name: 'pageNumber',
  standalone: false
})
export class PageNumberPipe implements PipeTransform {

  transform(page: PageResult<any>, index: number): number {
    return (page.number * page.size) + index + 1;
  }

}
